import { configureStore } from '@reduxjs/toolkit';
import authReducer from '../features/auth/authSlice';
import usersReducer from '../features/users/usersSlice';
import customersReducer from '../features/customers/customersSlice';

// Root reducer with reset capability
const rootReducer = (state, action) => {
  // When logout action is dispatched, reset all state
  if (action.type === 'auth/logout') {
    // Clear all localStorage
    localStorage.clear();
    
    // Return initial state for all reducers
    state = undefined;
  }
  
  return {
    auth: authReducer(state?.auth, action),
    users: usersReducer(state?.users, action),
    customers: customersReducer(state?.customers, action),
  };
};

const store = configureStore({
  reducer: rootReducer,
});

export default store;
